import React, { useContext, useState, useCallback, useEffect } from "react";
import { AuthContext } from "../../context/auth/AuthContext";
import Error from "../../components/Error";
import Loading from "../../components/Loading";
import { useHistory } from "react-router";
import { UsePlants } from "../../api/plant/Plant.api";
import useUpdateEkloks from "../../hooks/useUpdateEkloks";
import { UseMe } from "../../api/users/Me.api";
import { Fragment } from "react";

const ListPlantsContainer = ({ children }) => {
  const history = useHistory();
  const [item, setItem] = useState(null);
  const [addAction, setAddAction] = useState(false);
  const { token } = useContext(AuthContext);
  const { content, loading, error, trigger } = UsePlants(token);
  const { content: user } = UseMe(token);
  const [updateStatus, reloadEkloks] = useUpdateEkloks(
    token,
    content
      ? content.map((item) => (item.ekloks.length > 0 ? item.ekloks[0] : null))
      : [],
  );
  const [date, setOpenDate] = useState(null);

  const onConnectDevice = useCallback((item) => {
    setOpenDate(new Date().getTime());
    setItem(item);
  }, []);

  const onCloseDevice = useCallback(() => {
    setOpenDate(null);
    setItem(null);
  }, []);

  const onViewAllAction = useCallback(() => {
    history.push("/app/plants");
  }, [history]);

  const onUpdateRowsAndPages = useCallback(
    (items) => {
      reloadEkloks(
        items.map((item) =>
          item.ekloks.length > 0 ? item.ekloks[0].id : null,
        ),
      );
    },
    [reloadEkloks],
  );

  useEffect(() => {
    if (user && user.groups) {
      switch (user.groups[0].name) {
        case "Installer":
          setAddAction(true);
          break;
        default:
          setAddAction(false);
          break;
      }
    }
  }, [user]);

  return (
    <Fragment>
      {error ? <Error message={error.message} /> : null}
      {loading ? <Loading /> : null}
      {children({
        onConnectDevice,
        onCloseDevice,
        onViewAllAction,
        onUpdateRowsAndPages,
        trigger,
        content,
        item,
        updateStatus,
        reloadEkloks,
        addAction,
        date,
      })}
    </Fragment>
  );
};

export default ListPlantsContainer;
